import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { Card } from 'primeng/card';
import { PreviewDataType } from '../../../../../../../../shared/enums/preview-data-type.enum';
import { PreviewDataWrapperComponent } from '../../../../../../../../shared/components/preview-data-wrapper/preview-data-wrapper.component';
import { AdminPanelUserDataSectionField } from '../../../../../../../../shared/models/admin-panel-user-data-section-field';

@Component({
  selector: 'app-admin-panel-user-organization-data-section',
  imports: [Card, PreviewDataWrapperComponent],
  templateUrl: './admin-panel-user-organization-data-section.component.html',
  styleUrl: './admin-panel-user-organization-data-section.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AdminPanelUserOrganizationDataSectionComponent {
  sectionTitle = input.required<string>();
  fields = input.required<AdminPanelUserDataSectionField[]>();
  protected readonly PreviewDataType = PreviewDataType;
}
